import React from 'react';

interface IState {
    readonly showToast: boolean;
}
interface Iprops {
    type: 'consent' | 'block' | 'authorization' | 'password';
    className?: string;
    handleClose?: () => void;
    geolocationBlock?: boolean;
}

class Toast extends React.Component<Iprops, IState> {
    // eslint-disable-next-line
    constructor(props: any) {
        super(props);
        this.state = {
            showToast: true,
        };
    }

    componentWillReceiveProps(prevProps: Readonly<Iprops>): void {
        console.log(this.props.geolocationBlock);
        if (this.props.geolocationBlock && !this.state.showToast) {
            this.setState({ showToast: true });
        }
    }

    render() {
        const { type } = this.props;
        return this.state.showToast ? (
            type === 'password' ? (
                <div className="toast-container">
                    <div className={`toast-card exclamation ${this.props.className}`}>
                        <div className="title">Credenciales incorrectas</div>
                        <div className="description">Los datos ingresados no coinciden, revisa tu información y vuelve a intentar.</div>
                        <div
                            className="close-icon"
                            onClick={() => {
                                if (this.props.handleClose) this.props.handleClose();
                                this.setState({ showToast: false });
                            }}
                        >
                            <img alt="close" src={require('../../assets/media/img/login/close.svg')} />
                        </div>
                    </div>
                </div>
            ) : (
                <div id="FXd__geolocation-warning" className={`component-geolocation-warning exclamation ${this.props.className}`}>
                    {type === 'block'
                        ? 'Valiu no tiene permiso para usar tu ubicación.'
                        : type === 'consent'
                        ? 'Valiu necesita acceder a tu ubicación por seguridad.'
                        : 'Valiu necesita tu autorización para acceder a tus datos de Banco BASE.'}
                    <div className="close-icon" onClick={() => this.setState({ showToast: false })}>
                        <img alt="close" src={require('../../assets/media/img/login/close.svg')} />
                    </div>
                </div>
            )
        ) : (
            <></>
        );
    }
}

export default Toast;
